<template>
  <div id="pubTable">
    <div class="el-table--border">
      <table cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          <col width="100">
          <col width="360">
          <col width="">
          <col width="125">
          <col width="115">
          <col width="115">
        </colgroup>
        <tr v-for="(item,index) in info" :key="index">
          <td style="background: #F7F9FC;">
            {{item.id.value}}
          </td>
          <td>
            <el-input type="textarea" autosize v-model="item.target.value" maxlength="200" :readonly="!status == 1 || !!item.target.disable">
              </el-input>
          </td>
          <td>
            <el-input type="textarea" autosize v-model="item.weight.value" maxlength="200" :readonly="!status == 1 || !!item.weight.disable">
              </el-input>
          </td>
          <!--  -->
          <td>
            <el-tooltip 
              class="item" 
              effect="dark" 
              content="此项默认为负数，直接输入数字即可" 
              placement="top"
              v-if="status == 1 && !item.self_rating.disable" :manual='index!=1'>
              <el-input-number 
                v-model="item.self_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="index == 1 ? -5 : 0" 
                :max="index == 1 ? 0 : 5" 
                size="small" 
                @change="getSelfRatingTotal"
              ></el-input-number>
            </el-tooltip>
            <span v-else>{{item.self_rating.value}}</span>
          </td>
          <td>
            <el-tooltip 
              class="item" 
              effect="dark" 
              content="此项默认为负数，直接输入数字即可" 
              placement="top"
              v-if="status == 1 && !item.second_rating.disable" :manual='index!=1'>
              <el-input-number 
                v-model="item.second_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="index == 1 ? -5 : 0" 
                :max="index == 1 ? 0 : 5" 
                size="small" 
                @change="getThirdRatingTotal"
              ></el-input-number>
            </el-tooltip>
            <span v-else>{{item.second_rating.value}}</span>
          </td>
          <td>
            <el-tooltip 
              class="item" 
              effect="dark" 
              content="此项默认为负数，直接输入数字即可" 
              placement="top"
              v-if="status == 1 && !item.third_rating.disable" :manual='index!=1'>
            <el-input-number 
                v-model="item.third_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="index == 1 ? -5 : 0" 
                :max="index == 1 ? 0 : 5" 
                size="small" 
                @change="getThirdRatingTotal"
              ></el-input-number>
            </el-tooltip>
              <span v-else>{{item.third_rating.value}}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3" align="right" style="font-weight:bold;text-align: right; font-size:14px">总计得分：</td>
          <td class="totalStyle">{{selfRatingTotal || '0'}}</td>
          <td class="totalStyle">{{secondRatingTotal || '0'}}</td>
          <td class="totalStyle">{{thirdRatingTotal || '0'}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { collect } from 'collect.js'
export default {
  data() {
    return {
      selfRatingTotal:0, //自评分总分
      secondRatingTotal:0, //直接上级打分
      thirdRatingTotal:0, // 上上级打分
    }
  },
  props:['info','k','status','enableModule'],
  mounted(){
    let that = this
    setTimeout(function(){
      that.getSelfRatingTotal()
      that.getSecondRatingTotal()
      that.getThirdRatingTotal()
    },500)
  },
  methods:{
    // 自评分总分
    getSelfRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.selfRatingTotal = collection.sum(product => Number(product.self_rating.value));
      },500)
    },
    // 直接上级打分总分
    getSecondRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.secondRatingTotal = collection.sum(product => Number(product.second_rating.value));
      },500)
    },
    // 上上级复核打分总分
    getThirdRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.thirdRatingTotal = collection.sum(product => Number(product.third_rating.value));
      },500)
    },
  }
}
</script>
<style scoped>
table {
  width: 100%;
}
</style>